import { Sport } from '@/constants';
import type { DataTableHeader } from '@/types/vuetify';
import { createPregamePageHeadersBasketball } from './PregamePageHeadersBasketball';
import { createPregamePageHeadersFootball } from './PregamePageHeadersFootball';

export function createPregamePageHeaders(sportId: number): DataTableHeader[] {
    if (sportId === Sport.Basketball) {
        return createPregamePageHeadersBasketball();
    }
    return createPregamePageHeadersFootball();
}
